module.exports = __webpack_public_path__ + "img/TXT_document_icon@2x.049291d0.png";